<template>
  <div v-easyadmin="easyadminId" 
    class="w-100 position-relative"
    :class="[contentType, containerClasses, {'bg-vodafone': content.theme == 'dark' && !content.background_color && !content.background_image}]" 
    v-if="isContentVisibleToUser()" 
    :style="[theme, containerStyles]" slide-images-component
  >
    <div class="position-relative overflow-hidden container h-100">
  	 	<div 
        v-if="content.background_image && !propagateBackground"
        :style="{'background-image': getContentResponsiveImageURL('background_image')}"
        class="w-100 h-100 position-absolute-center bg-cover-center" 
      ></div>
      <div class="row h-100 justify-content-center" :style="contentStyle">
        <div class="col-12 d-flex flex-column px-sm-4 px-md-3 text-column" :class="textColumnClasses">
          <simple-text-component 
            :content="content"
            :opt-container-content="containerContent"
            :active-story="activeStory"
          ></simple-text-component>
        </div>
      </div>
    </div>
    <div 
      v-for="(image, key) in content.images"
      :class="[{'active': activeStory}, `image--${key}`]"
      class="bg-contain-center image"
      :style="{'background-image': getContentResponsiveImageURL(key, content.images)}"
    ></div>
  </div>
</template>

<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  props: {
    activeStory: {
      type: Boolean
    }
  },
  data: function() {
    return {};
  },
  methods: {
    getContentResponsiveImage: Fandom.getContentResponsiveImage,
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL,
  },
  computed: {
    propagateBackground() {
      return this.content.propagate_background ?? false;
    },
    containerStyles() {
      return {
        "background-image": this.propagateBackground ? this.getContentResponsiveImageURL("background_image") : ""
      };
    },
    containerClasses() {
      return this.propagateBackground ? "themed-item bg-cover-center" : "";
    },
    textColumnWidth() {
      return parseInt(this.content.text_column_width ?? 8);
    },
    contentStyle() {
      const style = {};

      if (!this.content.theme) {
        style["color"] = this.content.text_color ? this.content.text_color : "inherit";
      }

      if (!!this.content.background_color) {
        style["background-color"] = this.content.background_color;
      }

      return style;
    },
    textColumnClasses() {
      const verticalAlign = this.content.vertical_align ?? "center";
      return [
        `col-lg-${this.textColumnWidth}`,
        `justify-content-${verticalAlign}`
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
[slide-images-component] {
  background-color: var(--theme-background);
  color: var(--theme-color);

  .text-column {
    z-index: 1;
    padding-top: var(--navigation-height);
    padding-bottom: var(--navigation-height);
  }

  .image {
    position: absolute;
    aspect-ratio: 9 / 16;
    opacity: 0;
    border-radius: .75rem;
    transition: transform .5s cubic-bezier(0.65, 0, 0.35, 1) .4s, opacity .5s cubic-bezier(0.65, 0, 0.35, 1) .4s;

    &--top {
      width: 22%;
      top: calc(20vh);
      left: calc(22vw);

      @include media-breakpoint-down(md) {
        width: 38%;
      }

      &.active {
        transform: translate(-22vw, -20vh);
        opacity: 1;
      }
    }

    &--center {
      width: 22%;
      top: 25vh;
      right: 20vw;

      @include media-breakpoint-down(md) {
        width: 35%;
        left: 40vw;
        right: unset;
      }
      
      &.active {
        transform: translateX(20vw);
        opacity: 1;
      }
    }

    &--bottom {
      width: 25%;
      top: 50%;
      left: 35vw;

      @include media-breakpoint-down(md) {
        width: 50%;
      }

      &.active {
        transform: translateY(30%);
        opacity: 1;
      }
    }
  }

  ::v-deep {
    [simple-text-component] {
      [description] {
        font-family: 'VodafoneEx';
      }
    }
  }
}
</style>
